export default "__VITE_ASSET__Dzjbe35X__"